import { IApiEvidenceStatus, IApiEvidenceStatusConnection, IApiEvidenceStatusFilter } from './../../../modules/graphql/types/types';
import { ApiConnection } from 'src/app/shared/decorators/@ApiConnection.decorator';
import { DataSource } from "@angular/cdk/collections";
import { EvidenceStatusService } from "./evidence-status.service";
import { NefcoPagedDataSource } from '../../../helpers/nefco-data-source.class';

export class EvidenceStatusDataSource extends NefcoPagedDataSource<IApiEvidenceStatus, EvidenceStatusService, IApiEvidenceStatusConnection> implements DataSource<IApiEvidenceStatus> {
  @ApiConnection()
  public load(filters: IApiEvidenceStatusFilter[] = []): Promise<IApiEvidenceStatusConnection> {
    return this.service.get(filters, this.listPage).toPromise();
  }
}
